{
  "types": {
    "percentage": "% 引き",
    "fixed": "円引き",
    "free_shipping": "送料無料",
    "bxgy": "まとめ買いでもう 1 点無料"
  },
  "types_help": {
    "percentage": "例：カード 10% 引き",
    "fixed": "例：注文から 500 円引き",
    "free_shipping": "お客様の送料が 0 円",
    "later": "後日対応"
  },
  "value": {
    "percent": "{{percent}}% 引き",
    "amount": "{{amount}} 引き"
  },
  "channels": {
    "web": "Webサイト",
    "pos": "店頭レジ"
  },
  "state": {
    "active": "使える",
    "scheduled": "まだ始まっていない",
    "expired": "終了",
    "used_up": "使い切り",
    "inactive": "オフ"
  },
  "columns": {
    "code": "コード",
    "value": "内容",
    "channels": "使える場所",
    "period": "期間",
    "used": "利用",
    "state": "状態"
  },
  "period": {
    "now": "今から",
    "no_end": "終わりなし",
    "always": "いつでも"
  },
  "used": {
    "of": "{{used}} / {{limit}}",
    "count_other": "{{count}} 回"
  },
  "filters": {
    "q": "検索",
    "q_placeholder": "コードか名前",
    "active": "オンのもの",
    "type": "種類"
  },
  "list": {
    "intro": "お客様がレジで入力、または店頭で伝えるコード。委託品は委託者が許可したものだけ割引されます（最大 10%）。",
    "create": "新しいコード"
  },
  "usage": {
    "title": "使われた注文",
    "count": "利用",
    "total": "割引の合計：",
    "none": "まだ使われていません。"
  },
  "locales": {
    "en": "English",
    "ja": "日本語",
    "th": "ไทย",
    "zh_Hant": "繁體中文",
    "zh_Hans": "简体中文"
  },
  "product_types": {
    "raw_single": "シングルカード",
    "graded_single": "鑑定カード",
    "sealed_product": "未開封 BOX／パック"
  },
  "problems": {
    "code": "英数字（と - _）3〜64 文字、先頭は英数字。",
    "percent": "0〜100 の % を入れてください。",
    "amount": "金額を円（整数）で入れてください。",
    "collections": "コレクションを 1 つ以上選んでください。",
    "types": "商品の種類を 1 つ以上選んでください。",
    "channels": "Webサイト、店頭、または両方を選んでください。",
    "count": "整数、または空欄で制限なし。",
    "period": "終わりは始まりより後にしてください。",
    "fix_other": "先に {{count}} か所を直してください。"
  },
  "form": {
    "load_failed": "コードを開けませんでした",
    "back": "コード一覧",
    "new_title": "新しい割引コード",
    "tabs": "コード",
    "tab_settings": "設定",
    "tab_usage_other": "利用（{{count}}）",
    "kind": "どんな割引？",
    "code_block": "コードと名前",
    "code": "お客様が入力するコード",
    "code_hint": "大文字と数字、例：WEEKEND10",
    "suggest": "自動で作る",
    "code_locked": "このコードは使われたため、名前を変えられません。",
    "titles": "お客様に見える名前（任意）",
    "how_much": "いくら？",
    "percent": "割引率",
    "amount": "割引額",
    "shipping_where": "送料無料の国",
    "shipping": {
      "everywhere": "すべての国",
      "japan": "日本だけ"
    },
    "applies": "対象",
    "applies_to": {
      "all": "お店全体",
      "collections": "一部のコレクション",
      "types": "一部の商品の種類"
    },
    "collections_search": "コレクションを探す",
    "collections_none": "コレクションが見つかりません。",
    "collection_count_other": "{{count}} 点",
    "conditions": "条件",
    "channels": "使える場所",
    "min_subtotal": "最低注文金額",
    "min_subtotal_hint": "空欄 = 金額なし。",
    "usageLimit": "全体で使える回数",
    "perCustomerLimit": "お客様 1 人あたりの回数",
    "limit_hint": "空欄 = 制限なし。",
    "groups_later": "顧客グループ向けのコードは後日対応です。",
    "when": "期間",
    "this_weekend": "今週末",
    "startsAt": "開始",
    "endsAt": "終了",
    "jst": "日本時間。",
    "consigned": "委託品",
    "respects": "委託者の選択に従う",
    "respects_help": "委託品は委託者が許可したものだけ、最大 {{max}}% まで割引されます。",
    "warning": {
      "over_limit": "{{percent}}% は {{max}}% を超えています：委託品は最大 {{max}}%（委託者が許可したものだけ）、お店の商品は {{percent}}% になります。",
      "ignores_consignor": "委託者に聞かずに委託品も割引されます。すべての委託者が同意している場合だけにしてください。"
    },
    "active": "オン（お客様が使える）",
    "save": "変更を保存",
    "create": "コードを作る",
    "read_only": "コードを変更できるのはオーナーか店長だけです。",
    "saved": "{{code}} を保存しました",
    "created": "{{code}} ができました",
    "stale": "このコードはいま誰かが変更しました。もう一度開いてください。",
    "switch_off": "オフにする",
    "switch_on": "オンにする",
    "switched_off": "{{code}} をオフにしました",
    "switched_on": "{{code}} をオンにしました",
    "delete": "削除",
    "delete_title": "{{code}} を削除しますか？",
    "delete_consequence": "コードはなくなり、お客様は使えなくなります。",
    "delete_used": "このコードは使われたので履歴に残ります。代わりにオフにしてください。",
    "deleted": "{{code}} を削除しました",
    "in_use": "このコードは使われています — 代わりにオフにしてください。"
  }
}
